"use client";

import styles from "./styles.module.scss";
import FilterOutlinedLogo from "/public/_a/icons/programListing/filter.svg";
import HatLogo from "/public/_a/icons/programListing/hat.png";
import DocumentsLogo from "/public/_a/icons/programListing/document.png";
import HistoryLogo from "/public/_a/icons/programListing/history.png";
import TrendingLogo from "/public/_a/icons/programListing/trending.png";
import DegreeProgramCard from "@molecules/DegreeProgramCard/DegreeProgramCard";
import Image from "next/image";
import { useCallback, useEffect, useRef, useState } from "react";
import cn from "clsx";
import ProgramFiltersMenu from "../ProgramFiltersMenu/ProgramFiltersMenu";
import useOnScreen from "@/helpers/Onscreen";

const ImagesList = [
  { src: HatLogo, alt: "filter-by-program-type" },
  { src: DocumentsLogo, alt: "filter-by-domain" },
  { src: HistoryLogo, alt: "filter-by-duration" },
  { src: TrendingLogo, alt: "filter-by-trending-programs" },
];

export default function ProgramsWithFilter({
  programs,
  filteredPrograms,
  isDesktop,
  toggleFilters,
  isFiltersOpen,
  setFilteredPrograms,
  setIsFiltersApplied,
  isFiltersApplied,
  isProgramSpecific = false,
  setPreviousPrograms,
  setQuery,
  query,
  isCertification = false
}) {

 
  const [displayedPrograms, setDisplayedPrograms] = useState([]);
  const programCardRef = useRef(null);
  const visibleRef = useRef(null);
  const onScreen = useOnScreen(visibleRef);

  useEffect(() => {
    if (filteredPrograms.length !== displayedPrograms.length) {
      const newDisplayedPrograms = isDesktop
        ? filteredPrograms?.slice(0, displayedPrograms?.length + 6)
        : filteredPrograms?.slice(0, displayedPrograms?.length + 4);
      setDisplayedPrograms(newDisplayedPrograms);
    }
  }, [onScreen]);

  useEffect(() => {
    setDisplayedPrograms(isDesktop ? filteredPrograms?.slice(0, 6) : filteredPrograms?.slice(0, 4));
  }, [filteredPrograms]);

  return (
    <>
    <div className={styles.programsRoot}>
      <div
        className={cn(styles.filtersDesktop, {
          ["!max-w-0 !opacity-0 !p-0 !h-0"]: !isFiltersOpen || !isDesktop,
        })}
      >
        <ProgramFiltersMenu
          programs={programs}
          toggleFilters={toggleFilters}
          setFilteredPrograms={setFilteredPrograms}
          setIsFiltersApplied={setIsFiltersApplied}
          isProgramSpecific={isProgramSpecific}
          setPreviousPrograms={setPreviousPrograms}
          query={query}
          setQuery={setQuery}
        />
      </div>
      <div
        className={cn(styles.filterTypes, {
          ["!hidden"]: isFiltersOpen,
        })}
      >
        <div
          className={cn("w-fit mx-auto", {
            [styles.activeFilters]: isFiltersApplied && isDesktop,
          })}
        >
          <Image
            src={FilterOutlinedLogo}
            alt="Apply Filters"
            onClick={toggleFilters}
            className="cursor-pointer"
          />
        </div>
        {ImagesList.map((image, i) => (
          <Image src={image?.src} alt={image?.alt || ""} onClick={toggleFilters} key={i} />
        ))}
      </div>
      <div className={styles.programCount}>
        <p
          className={cn(styles.count, {
            ["!px-0"]: isFiltersOpen && isDesktop,
          })}
        >
          {`Showing ${
            filteredPrograms.length
          } ${
            displayedPrograms?.length === 1 || displayedPrograms?.length === 0
              ? isCertification ? "Certification Program" : "Program"
              : isCertification ?  "Certification Programs" : "Programs"
          }`}
        </p>
        <div
          className={cn(styles.programsContainer, {
            ["!grid-cols-2"]: isFiltersOpen && isDesktop,
          })}
          ref={programCardRef}
        >
          {displayedPrograms?.map((item, i) => (
            <DegreeProgramCard key={i} {...item?.attributes?.BasicDetails} isSmall scroll />
          ))}
        </div>
      </div>
    </div>
    <div ref={visibleRef}>.</div>
  </>  
  );
}
